import * as JSZip from "jszip";
import { AudioEditor } from "../../AudioEditor";
import { ClipExport } from "./ClipExport";
import * as FileSaver from "file-saver"; 
export class ClipExporter
{
  audioEditor:AudioEditor;
  worker:Worker;
  
  async exportClips():Promise<void>
  {
    this.createWorker();

    let exportSettings = this.audioEditor.project.exportSettings;

    let zip = new JSZip();
    
    for ( let clip of exportSettings.exports.data )
    {
      console.log( "Processing:", clip );
      let data = await this.createWavFromClip( clip );

      console.log( "Zipping:", clip );

      zip.file( clip.clipName + ".wav", data );

    }

    let zipData = await zip.generateAsync( { type:"blob" } ) as Blob;

    FileSaver.saveAs( zipData, exportSettings.naming.exportName + ".zip" ); 

    return Promise.resolve();
  } 

  createWorker()
  {
    this.worker = new Worker( new URL( "./RecorderWorker.ts", import.meta.url ) );

    console.log( this.worker );

    this.worker.onmessage = ( message:MessageEvent) =>
    {
      console.log( "Onmessage:", message );

      let data = message.data;
      this.resolveWorkerData( data );
    };

    this.worker.postMessage( { command: "init", config:{ sampleRate:44100 } } );
  }

  _cachedResolve:(data:any)=>void;

  createWavFromClip( clipExport:ClipExport ):Promise<Blob>
  {
    let promise = new Promise<Blob>(
      ( resolve, reject )=>
      {
        this._cachedResolve = resolve;

        this.worker.postMessage( { command: "clear" } );

        let duration = ClipExport.getTimeDuration( clipExport );
        let audio = this.audioEditor.project.audioBuffer;
        let samples = Math.floor( audio.sampleRate * duration );
      
        let left  = new Float32Array( samples );
        let right = new Float32Array( samples );

        let start = Math.floor( ClipExport.getStartTime( clipExport ) * audio.sampleRate );

        console.log( "Copying data" );

        audio.copyFromChannel( left, 0, start ); 
        audio.copyFromChannel( right, 1, start ); 

        if ( clipExport.fadeInDuration > 0 )
        {
          let samples = audio.sampleRate * clipExport.fadeInDuration;
          let end = Math.min( samples, left.length );

          for ( let i = 0; i < end; i++ )
          {
            let fade = i / ( end - 1 );

            left[ i ]  = left[ i ] * fade;
            right[ i ] = right[ i ] * fade;
          }
        }

        if ( clipExport.fadeOutDuration > 0 )
        { 
          let samples = audio.sampleRate * clipExport.fadeOutDuration;
          let end = Math.min( samples, left.length );

          for ( let i = 0; i < end; i++ )
          {
            let fade = i / ( end - 1 );

            let index = ( left.length - 1 ) - i ;

            left[ index ]  = left[ index ] * fade;
            right[ index ] = right[ index ] * fade;
          }
        }

        console.log( "sending to worker" );

        
        this.worker.postMessage( { command: "record", buffer: [ left, right ] } );
        this.worker.postMessage( { command: "exportWAV", type:"audio/wav" } );
      }
    )
    
    return Promise.resolve( promise );

  }

  resolveWorkerData( data:any ):void
  {
    this._cachedResolve( data );
  }


}

 